<template>
  <div class="aboutIntro">
    <div>
      <div class="compText">盛唐中融保险经纪（深圳）有限公司为北京壹心壹翼科技有限公司的控股子公司。</div>
      <div class="compText">
        <p>壹心壹翼科技有限公司致力打造受人信赖的 OMO(Online-Merge-Offline) 数智化保险云服务平台，平台内核由 SaaS 化“三朵云”和“保险超脑”组成。</p>
        <p style="text-indent:-7px;">「云桥」：专项链接和整合保险公司产品与服务，形成智慧产品工厂。</p>
        <p style="text-indent:-7px;">「云创」：数字化保险中后台管理系统（核心业务系统）和代理人展业平台（鲸云保 APP）。</p>
        <p style="text-indent:-7px;">「云链」：链接大型央企B2B供应平台及政府中小企业服务平台，实现获客引流，形成线上保险服务链。</p>
        <p style="text-indent:-7px;">「保险超脑」：立足数据建模与算法等科技手段打造的超级智慧体。</p>
        <p>形成保险交易服务中供给端、需求端及销售端的闭环链路，助力精准交易与服务，推动行业在效率、成本、用户体验、风险管理、信用构建五大方面转型优化，为经济发展及社会效益贡献价值。</p>
      </div>
      <div class="compText">壹心官网：<a href="https://www.yxinsur.com/index.html">https://www.yxinsur.com/index.html</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutIntro',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.aboutIntro {
  width: 1024px;
  margin: 0 auto;

  a {
    color: #2488CA;
  }

}
</style>